export class CreateConsumptionLineRequest {
  constructor(
    public itemId: number,
    public quantity: number,
    public lot: string | undefined,
    public bestBefore: string | undefined,
    public expiry: string | undefined
  ) {}
}

export default class CreateConsumptionRequest {
  constructor(
    public siteId: number,
    public referenceCode: string,
    public nonBillable: boolean,
    public lines: CreateConsumptionLineRequest[],
    public pmsMandatorId?: string,
  ) {}
}
